var config = {
  dev: {
    pxAuthGateClientOrigin: 'https://gateway.test.cheggnet.com'
  },
  test: {
    pxAuthGateClientOrigin: 'https://gateway.test.cheggnet.com'
  },
  prod: {
    pxAuthGateClientOrigin: 'https://gateway.chegg.com'
  }
};
export default config;